module.exports = __webpack_public_path__ + "img/content_4.1d269836.png";